import * as $ from 'jquery';
var TramitesComponent = /** @class */ (function () {
    function TramitesComponent() {
        $(document).ready(function () {
            $('[id^=detail-]').hide();
            $('.toggle').click(function () {
                var input = $(this);
                var target = $('#' + input.attr('data-toggle'));
                target.slideToggle();
            });
        });
    }
    return TramitesComponent;
}());
export { TramitesComponent };
